import { TransferChannelType, TransferType } from "@/common/types";
import { MessagingInProgressActionButtons } from "./MessagingInProgressActionButtons";
import { closeGeneric } from "@/repository/queryFns";

export const GenericInProgressActionButtons = () => {
    return <MessagingInProgressActionButtons
        transferType={TransferType.AgentTransfer}
        transferIVRType={TransferType.IvrTransfer}
        transferChannelType={TransferChannelType.Generic}
        closeInteraction={closeGeneric}
    />;
}